export const LABELS = {
  project: 'Project',
  projects: 'Projects',
  unassigned: 'Unassigned',
}
